import { useMemo } from "react";

const SOURCES = { linkedin: "LinkedIn", twitter: "X", instagram: "Instagram", google: "Google" };
const TIME_LABELS = { morning: "Good morning", afternoon: "Good afternoon", evening: "Good evening", night: "Late night" };

/**
 * useContextAwareness Hook
 * 
 * Detects the user's local time and referrer source to provide
 * context-aware greetings and time-based theming.
 */
export function useContextAwareness() {
    const contextData = useMemo(() => {
        const now = new Date();
        const hour = now.getHours();

        // Determine time of day
        let timeOfDay;
        if (hour >= 0 && hour < 6) {
            timeOfDay = "night";
        } else if (hour >= 6 && hour < 12) {
            timeOfDay = "morning";
        } else if (hour >= 12 && hour < 18) {
            timeOfDay = "afternoon";
        } else {
            timeOfDay = "evening";
        }

        // Determine referrer - check both document.referrer AND UTM parameters
        let referrer = null;
        const referrerUrl = document.referrer.toLowerCase();
        const urlParams = new URLSearchParams(window.location.search);
        const utmSource = (urlParams.get("utm_source") || "").toLowerCase();

        // Check UTM source first (more reliable for social platforms)
        if (utmSource === "ig" || utmSource === "instagram") {
            referrer = "instagram";
        } else if (utmSource === "linkedin" || utmSource === "li") {
            referrer = "linkedin";
        } else if (utmSource === "twitter" || utmSource === "x") {
            referrer = "twitter";
        } else if (referrerUrl.includes("linkedin.com")) {
            referrer = "linkedin";
        } else if (referrerUrl.includes("twitter.com") || referrerUrl.includes("x.com")) {
            referrer = "twitter";
        } else if (referrerUrl.includes("instagram.com")) {
            referrer = "instagram";
        } else if (referrerUrl.includes("google.com")) {
            referrer = "google";
        }

        // Plain, short copy: the hero shows welcomeText as a label and the
        // greeting right before its "Let's build together" link.
        const source = SOURCES[referrer] || null;
        const welcomeText = source ? `From ${source}` : TIME_LABELS[timeOfDay];
        const greeting = referrer && referrer !== "google"
            ? "You've seen the posts. Here's the work."
            : "Currently taking on new projects.";

        return {
            timeOfDay,
            referrer,
            source,
            greeting,
            welcomeText,
        };
    }, []);

    return contextData;
}

export default useContextAwareness;

